import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

// Public routes that should not trigger login redirect on 401
const PUBLIC_ROUTES = ['/shared/', '/login'];

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Only redirect to login on certain endpoints
      const url = error.config?.url || '';
      const shouldRedirect = [
        '/auth/me'
      ].some(endpoint => url.includes(endpoint));
      
      // Don't redirect if we're on a public route
      const isPublicRoute = PUBLIC_ROUTES.some(route => 
        window.location.pathname.startsWith(route)
      );
      
      if (shouldRedirect && !isPublicRoute) {
        localStorage.removeItem('accessToken');
        window.location.href = '/login';
      }
      // For document endpoints, let the component handle the error
    }
    return Promise.reject(error);
  }
);
